import SparkleIcon from "@/assets/icons/sparkles.svg";
import { useOrganization } from "@/hooks/useOrganization";
import useSearchParams from "@/hooks/useSearchParams";
import { PlanDisplay } from "@components/DataDisplay";
import IconBall from "@components/IconBall";
import Modal, { ModalContent } from "@components/Modal";
import Typography from "@components/Typography";

import styles from "./PaymentSuccess.module.css";

const PaymentSuccess = () => {
  const { data: orgData } = useOrganization();
  const { plan = null } = orgData?.ok && orgData.data ? orgData.data : {};
  const [{ payment_success }, setParams] = useSearchParams<{
    payment_success?: boolean;
  }>();

  return (
    <Modal
      show={Boolean(payment_success)}
      onHide={() => {
        setParams({ payment_success: undefined });
      }}
      data-testid="payment-success-modal"
    >
      <ModalContent className={styles.root}>
        <IconBall icon={SparkleIcon} />
        <Typography variant="h3">
          {L.PLAN_UPGRADE_SUCCESS_MODAL_TITLE}
        </Typography>
        <Typography>
          {plan && (
            <PlanDisplay
              id={plan.type}
              render={(d) => {
                return L.PLAN_UPGRADE_SUCCESS_MODAL_SUBTITLE.replace("{}", d);
              }}
            />
          )}
        </Typography>
        <Typography
          dangerouslySetInnerHTML={{
            __html: L.PLAN_UPGRADE_SUCCESS_MODAL_HELP,
          }}
        ></Typography>
      </ModalContent>
    </Modal>
  );
};

export default PaymentSuccess;
